import { render, staticRenderFns } from "./BaseBtnClose.vue?vue&type=template&id=c1f0bde4&scoped=true&lang=pug"
import script from "./BaseBtnClose.vue?vue&type=script&lang=js"
export * from "./BaseBtnClose.vue?vue&type=script&lang=js"
import style0 from "./BaseBtnClose.vue?vue&type=style&index=0&id=c1f0bde4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f0bde4",
  null
  
)

export default component.exports